var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12", grow: "", shrink: "" } },
    [
      _c(
        "w-row",
        { attrs: { center: "" } },
        [
          _vm._t("default"),
          _c("w-spacer"),
          _c(
            "div",
            [
              _c(
                "w-col",
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c(
                        "w-button-bar",
                        { staticClass: "mr" },
                        [
                          _c(
                            "w-button",
                            {
                              attrs: {
                                disabled:
                                  _vm.registrations.length == 0 ||
                                  _vm.registering,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.registerForSelfBilling()
                                },
                              },
                            },
                            [_vm._v(" Self billing opzetten ")]
                          ),
                          _c(
                            "w-button",
                            {
                              attrs: {
                                disabled:
                                  _vm.registrations.length == 0 ||
                                  _vm.registering,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.unregisterForSelfBilling()
                                },
                              },
                            },
                            [_vm._v(" Self billing uitzetten ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-button-bar",
                        [
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.add()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "plus" } })],
                            1
                          ),
                          _c(
                            "w-button",
                            {
                              attrs: { disabled: _vm.selectedRows.length == 0 },
                              on: {
                                click: function ($event) {
                                  return _vm.remove()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "trash" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "" } },
        [
          _c(
            "w-col",
            [
              _c("w-data-table", {
                style: { flexGrow: 1 },
                attrs: {
                  columns: _vm.columns,
                  items: _vm.registrations,
                  "selected-items": _vm.selectedRows,
                  compare: _vm.compare,
                  "column-resize-handle": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.registerModalOpen
        ? _c("app-dossier-peppol-endpoint-create-modal", {
            attrs: { "dossier-id": _vm.dossier.id },
            on: {
              close: function ($event) {
                _vm.registerModalOpen = false
              },
              saved: function ($event) {
                return _vm.fetch()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }